import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { ClipboardList, KeyRound, Layers, MessageSquare } from 'lucide-react';

// Chaque affirmation correspond à un mécanisme réellement implémenté dans le produit.
const COPY = {
  fr: {
    eyebrow: 'Exploitation',
    title: 'Ce qui tient la plateforme',
    lede: "Une plateforme de fret manipule les coordonnées de clients, des montants et des "
      + 'preuves de livraison. Ces garde-fous sont intégrés au produit, pas ajoutés après coup.',
    items: [
      {
        icon: Layers,
        title: 'Cloisonnement par entreprise',
        text: 'Chaque donnée est rattachée à une entreprise et les requêtes portent cette '
          + "appartenance. Un compte d'une société ne peut pas atteindre le dossier d'une autre.",
      },
      {
        icon: KeyRound,
        title: 'Rôles et permissions',
        text: 'Administrateur, responsable pays, collecteur, partenaire de livraison, chargeur, '
          + 'client : chaque rôle ne voit et ne fait que ce que son métier exige.',
      },
      {
        icon: ClipboardList,
        title: 'Journal des actions',
        text: 'Création, modification, changement de statut, suppression avec motif : les '
          + 'opérations sensibles sont horodatées et attribuées à leur auteur.',
      },
      {
        icon: MessageSquare,
        title: 'Traçabilité des messages',
        text: 'Chaque notification envoyée au client est enregistrée avec son canal et son '
          + 'résultat, et les volumes mensuels sont suivis par entreprise.',
      },
    ],
  },
  en: {
    eyebrow: 'Operations',
    title: 'What holds the platform together',
    lede: 'A freight platform handles client contact details, amounts and delivery proofs. '
      + 'These safeguards are built into the product, not bolted on afterwards.',
    items: [
      {
        icon: Layers,
        title: 'Per-company partitioning',
        text: 'Every record belongs to a company and queries carry that ownership. An account '
          + "from one company cannot reach another company's records.",
      },
      {
        icon: KeyRound,
        title: 'Roles and permissions',
        text: 'Administrator, country manager, collector, delivery partner, loader, client: '
          + 'each role sees and does only what its job requires.',
      },
      {
        icon: ClipboardList,
        title: 'Action log',
        text: 'Creation, edition, status change, deletion with a reason: sensitive operations '
          + 'are timestamped and attributed to their author.',
      },
      {
        icon: MessageSquare,
        title: 'Message traceability',
        text: 'Every notification sent to a client is recorded with its channel and outcome, '
          + 'and monthly volumes are tracked per company.',
      },
    ],
  },
};

const TrustSection = () => {
  const { language } = useLanguage();
  const copy = COPY[language === 'en' ? 'en' : 'fr'];

  return (
    <section id="trust" className="landing-section">
      <div className="landing-section-inner">
        <span className="landing-section-eyebrow">{copy.eyebrow}</span>
        <h2 className="landing-section-title">{copy.title}</h2>
        <p className="landing-lede">{copy.lede}</p>

        <div className="landing-trust-grid">
          {copy.items.map(({ icon: Icon, title, text }) => (
            <article key={title} className="landing-trust-item">
              <span className="landing-trust-icon" aria-hidden="true">
                <Icon size={18} strokeWidth={1.75} />
              </span>
              <div>
                <h3>{title}</h3>
                <p>{text}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustSection;
